
import { useState } from 'react';
import { Link } from 'react-router-dom';

interface Plan {
  id: string;
  title: string;
  sessions: string;
  gender: 'Feminino' | 'Masculino';
  benefits: string[];
  originalPrice: string;
  finalPrice: string;
  installments: string;
  featured?: boolean;
  savings: string;
}

interface BeforeAfter {
  id: number;
  title: string;
  before: string;
  after: string;
}

export default function ClubeBotoxPage() {
  const [selectedGender, setSelectedGender] = useState<'Feminino' | 'Masculino'>('Feminino');
  const [showVideo, setShowVideo] = useState(false);
  const [sliderPositions, setSliderPositions] = useState<{ [key: number]: number }>({
    0: 50, // Added for video card
    1: 50,
    2: 50,
    3: 50,
    4: 50,
    5: 50
  });

  const beforeAfterImages: BeforeAfter[] = [
    {
      id: 1,
      title: '',
      before: 'https://clubebotox.peleplastica.com.br/antesedepois/Antes1.jpg',
      after: 'https://clubebotox.peleplastica.com.br/antesedepois/Depois1.jpg'
    },
    {
      id: 2,
      title: '',
      before: 'https://clubebotox.peleplastica.com.br/antesedepois/Antes2.jpg',
      after: 'https://clubebotox.peleplastica.com.br/antesedepois/Depois2.jpg'
    },
    {
      id: 3,
      title: '',
      before: 'https://clubebotox.peleplastica.com.br/antesedepois/Antes3.jpg',
      after: 'https://clubebotox.peleplastica.com.br/antesedepois/Depois3.jpg'
    },
    {
      id: 4,
      title: '',
      before: 'https://clubebotox.peleplastica.com.br/antesedepois/Antes4.jpg',
      after: 'https://clubebotox.peleplastica.com.br/antesedepois/Depois4.jpg'
    },
    {
      id: 5,
      title: '',
      before: 'https://clubebotox.peleplastica.com.br/antesedepois/Antes5.jpg',
      after: 'https://clubebotox.peleplastica.com.br/antesedepois/Depois5.jpg'
    }
  ];

  const plans: Plan[] = [
    {
      id: 'f1',
      title: '2 Sessões - Toxina Clássica',
      sessions: '2 Sessões',
      gender: 'Feminino',
      benefits: [
        '2 Toxinas Clássicas no ano',
        '1 sessão de Liftera (Área dos Olhos)',
        '2 sessões de Peeling Químico',
        'Adicional de Hidratação Nutritiva por apenas R$ 15,00 mensais',
        '1 voucher para campanhas mensais especiais',
        'Presente especial no mês da aquisição'
      ],
      originalPrice: 'R$ 5.600,00',
      finalPrice: 'R$ 2.988,00',
      installments: '12x de R$ 249,00',
      savings: 'Economize R$ 2.612,00'
    },
    {
      id: 'f2',
      title: '3 Sessões - Toxina Clássica',
      sessions: '3 Sessões',
      gender: 'Feminino',
      benefits: [
        '3 Toxinas Clássicas no ano',
        '1 sessão de Liftera (Área dos Olhos)',
        '3 sessões de Peeling Químico',
        'Adicional de Hidratação Nutritiva por apenas R$ 15,00 mensais',
        '1 voucher para campanhas mensais especiais',
        'Presente especial no mês da aquisição'
      ],
      originalPrice: 'R$ 7.550,00',
      finalPrice: 'R$ 4.482,00',
      installments: '12x de R$ 373,50',
      featured: true,
      savings: 'Economize R$ 3.068,00'
    },
    {
      id: 'f3',
      title: '2 Sessões - Toxina Full Face',
      sessions: '2 Sessões',
      gender: 'Feminino',
      benefits: [
        '2 Toxinas Full Face no ano',
        '1 sessão de Liftera (Área dos Olhos)',
        '2 sessões de Peeling Químico',
        'Adicional de Hidratação Nutritiva por apenas R$ 15,00 mensais',
        '1 voucher para campanhas mensais especiais',
        'Presente especial no mês da aquisição'
      ],
      originalPrice: 'R$ 7.400,00',
      finalPrice: 'R$ 4.780,00',
      installments: '12x de R$ 398,33',
      savings: 'Economize R$ 2.620,00'
    },
    {
      id: 'f4',
      title: '3 Sessões - Toxina Full Face',
      sessions: '3 Sessões',
      gender: 'Feminino',
      benefits: [
        '3 Toxinas Full Face no ano',
        '1 sessão de Liftera (Área dos Olhos)',
        '3 sessões de Peeling Químico',
        'Adicional de Hidratação Nutritiva por apenas R$ 15,00 mensais',
        '1 voucher para campanhas mensais especiais',
        'Presente especial no mês da aquisição'
      ],
      originalPrice: 'R$ 10.250,00',
      finalPrice: 'R$ 7.100,00',
      installments: '12x de R$ 591,67',
      savings: 'Economize R$ 3.150,00'
    },
    {
      id: 'm1',
      title: '2 Sessões - Toxina Clássica',
      sessions: '2 Sessões',
      gender: 'Masculino',
      benefits: [
        '2 Toxinas Clássicas no ano',
        '1 sessão de Liftera (Área dos Olhos)',
        '2 sessões de Peeling Químico',
        'Adicional de Hidratação Nutritiva por apenas R$ 15,00 mensais',
        '1 voucher para campanhas mensais especiais',
        'Presente especial no mês da aquisição'
      ],
      originalPrice: 'R$ 5.800,00',
      finalPrice: 'R$ 3.188,00',
      installments: '12x de R$ 265,67',
      savings: 'Economize R$ 2.612,00'
    },
    {
      id: 'm2',
      title: '3 Sessões - Toxina Clássica',
      sessions: '3 Sessões',
      gender: 'Masculino',
      benefits: [
        '3 Toxinas Clássicas no ano',
        '1 sessão de Liftera (Área dos Olhos)',
        '3 sessões de Peeling Químico',
        'Adicional de Hidratação Nutritiva por apenas R$ 15,00 mensais',
        '1 voucher para campanhas mensais especiais',
        'Presente especial no mês da aquisição'
      ],
      originalPrice: 'R$ 7.850,00',
      finalPrice: 'R$ 4.780,00',
      installments: '12x de R$ 398,33',
      featured: true,
      savings: 'Economize R$ 3.070,00'
    },
    {
      id: 'm3',
      title: '2 Sessões - Toxina Full Face',
      sessions: '2 Sessões',
      gender: 'Masculino',
      benefits: [
        '2 Toxinas Full Face no ano',
        '1 sessão de Liftera (Área dos Olhos)',
        '2 sessões de Peeling Químico',
        'Adicional de Hidratação Nutritiva por apenas R$ 15,00 mensais',
        '1 voucher para campanhas mensais especiais',
        'Presente especial no mês da aquisição'
      ],
      originalPrice: 'R$ 7.600,00',
      finalPrice: 'R$ 4.980,00',
      installments: '12x de R$ 415,00',
      savings: 'Economize R$ 2.620,00'
    },
    {
      id: 'm4',
      title: '3 Sessões - Toxina Full Face',
      sessions: '3 Sessões',
      gender: 'Masculino',
      benefits: [
        '3 Toxinas Full Face no ano',
        '1 sessão de Liftera (Área dos Olhos)',
        '3 sessões de Peeling Químico',
        'Adicional de Hidratação Nutritiva por apenas R$ 15,00 mensais',
        '1 voucher para campanhas mensais especiais',
        'Presente especial no mês da aquisição'
      ],
      originalPrice: 'R$ 10.550,00',
      finalPrice: 'R$ 7.470,00',
      installments: '12x de R$ 622,50',
      savings: 'Economize R$ 3.080,00'
    }
  ];

  const filteredPlans = plans.filter(plan => plan.gender === selectedGender);

  const handleWhatsApp = (plan?: Plan) => {
    const message = plan 
      ? `Olá! Quero garantir minha vaga no Clube Botox 2026! Tenho interesse no plano ${plan.title} (${plan.gender}) por ${plan.finalPrice} em ${plan.installments} sem juros.`
      : `Olá! Quero garantir minha vaga no Clube Botox 2026! Gostaria de mais informações sobre os planos disponíveis.`;
    window.open(`https://wa.me/556232741329?text=${encodeURIComponent(message)}`, '_blank');
  };

  const handleSliderMove = (id: number, e: React.MouseEvent<HTMLDivElement>) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const percentage = (x / rect.width) * 100;
    setSliderPositions(prev => ({
      ...prev,
      [id]: Math.max(0, Math.min(100, percentage))
    }));
  };

  return (
    <div className="min-h-screen bg-[#080705]">
      {/* Sticky Header */}
      <header className="bg-[#080705] shadow-2xl sticky top-0 z-50 border-b border-[#B9A38E]/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
          <div className="flex items-center justify-between">
            <Link to="/">
              <img 
                src="https://peleplastica.com.br/wp-content/uploads/2024/09/Logo.png" 
                alt="Pele e Plástica" 
                className="h-14 w-auto brightness-0 invert"
              />
            </Link>
            <a 
              href="https://wa.me/556232741329"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-full font-bold transition-all duration-300 flex items-center gap-2 whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              Quero Minha Vaga
            </a>
          </div>
        </div>
      </header>

      {/* Hero Section - Above the Fold */}
      <section className="relative bg-gradient-to-br from-[#080705] via-[#1a1816] to-[#080705] py-16 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-10 w-72 h-72 bg-[#B9A38E] rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#baa695] rounded-full blur-3xl"></div>
        </div>
        
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center space-y-6">
            {/* Urgency Badge */}
            <div className="inline-flex items-center gap-2 bg-red-600/20 text-red-400 border border-red-500/30 px-6 py-3 rounded-full font-bold text-sm animate-pulse">
              <i className="ri-time-line text-lg"></i>
              VAGAS LIMITADAS - Apenas 50 Membros em 2026
            </div>

            <h1 className="text-5xl lg:text-7xl font-black text-[#fefefe] leading-tight">
              Clube do Botox <span className="text-[#B9A38E]">2026</span>
            </h1>
            
            <p className="text-2xl lg:text-3xl font-bold text-[#fefefe]/90 max-w-4xl mx-auto">
              Garanta Sua Beleza Natural Durante Todo o Ano com Economia de até <span className="text-[#B9A38E]">R$ 3.150</span>
            </p>

            <p className="text-xl text-[#fefefe]/70 max-w-3xl mx-auto leading-relaxed">
              Tratamentos de toxina botulínica com a Dra. Ana Paula Rocha, especialista em resultados naturais e harmoniosos
            </p>

            {/* Main CTA */}
            <div className="pt-4">
              <a 
                href="#planos"
                className="inline-block bg-[#B9A38E] hover:bg-[#baa695] text-[#080705] px-12 py-5 rounded-full font-bold text-xl transition-all duration-300 shadow-2xl hover:shadow-xl hover:scale-105 cursor-pointer whitespace-nowrap"
              >
                Quero Garantir Minha Vaga Agora
                <i className="ri-arrow-down-line ml-2"></i>
              </a>
            </div>

            {/* Trust Indicators */}
            <div className="flex flex-wrap justify-center gap-8 pt-8">
              <div className="flex items-center gap-2 text-[#fefefe]/80">
                <i className="ri-shield-check-fill text-3xl text-green-500"></i>
                <div className="text-left">
                  <p className="font-bold">100% Seguro</p>
                  <p className="text-sm text-[#fefefe]/50">Clínica Certificada</p>
                </div>
              </div>
              <div className="flex items-center gap-2 text-[#fefefe]/80">
                <i className="ri-star-fill text-3xl text-yellow-500"></i>
                <div className="text-left">
                  <p className="font-bold">+4000 Clientes</p>
                  <p className="text-sm text-[#fefefe]/50">Satisfeitos</p>
                </div>
              </div>
              <div className="flex items-center gap-2 text-[#fefefe]/80">
                <i className="ri-award-fill text-3xl text-[#B9A38E]"></i>
                <div className="text-left">
                  <p className="font-bold">20+ Anos</p>
                  <p className="text-sm text-[#fefefe]/50">de Experiência</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Video Section */}
      <section className="py-20 bg-[#080705]">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl lg:text-5xl font-black text-[#fefefe] mb-4">
              Descubra Como Funciona o Clube Botox 2026
            </h2>
            <p className="text-xl text-[#fefefe]/70">
              Assista ao vídeo e entenda todos os benefícios exclusivos
            </p>
          </div>

          {/* Video Player */}
          <div className="relative bg-gradient-to-br from-[#B9A38E] to-[#baa695] rounded-3xl overflow-hidden shadow-2xl">
            <div className="aspect-video">
              <iframe
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/OBpBprYszpY"
                title="Clube Botox 2026"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                className="w-full h-full"
              ></iframe>
            </div>
          </div>

          {/* Video Benefits */}
          <div className="grid md:grid-cols-3 gap-6 mt-12">
            <div className="text-center p-6 bg-[#1a1816] rounded-2xl border border-[#B9A38E]/20">
              <i className="ri-calendar-check-line text-4xl text-[#B9A38E] mb-3"></i>
              <h3 className="font-bold text-lg mb-2 text-[#fefefe]">Planejamento Anual</h3>
              <p className="text-[#fefefe]/70 text-sm">Organize seus tratamentos com antecedência</p>
            </div>
            <div className="text-center p-6 bg-[#1a1816] rounded-2xl border border-[#B9A38E]/20">
              <i className="ri-price-tag-3-line text-4xl text-[#B9A38E] mb-3"></i>
              <h3 className="font-bold text-lg mb-2 text-[#fefefe]">Economia Real</h3>
              <p className="text-[#fefefe]/70 text-sm">Até 50% de desconto nos tratamentos</p>
            </div>
            <div className="text-center p-6 bg-[#1a1816] rounded-2xl border border-[#B9A38E]/20">
              <i className="ri-vip-crown-line text-4xl text-[#B9A38E] mb-3"></i>
              <h3 className="font-bold text-lg mb-2 text-[#fefefe]">Benefícios VIP</h3>
              <p className="text-[#fefefe]/70 text-sm">Acesso a campanhas exclusivas</p>
            </div>
          </div>

          {/* CTA after video */}
          <div className="text-center mt-12">
            <button
              onClick={() => handleWhatsApp()}
              className="bg-[#B9A38E] hover:bg-[#baa695] text-[#080705] px-10 py-4 rounded-full font-bold text-lg transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              Quero Garantir Minha Vaga Agora
            </button>
          </div>
        </div>
      </section>

      {/* Before/After Section */}
      <section className="py-20 bg-gradient-to-b from-[#1a1816] to-[#080705]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-block bg-[#B9A38E]/20 text-[#B9A38E] border border-[#B9A38E]/30 px-6 py-3 rounded-full font-bold text-sm mb-6">
              ✨ RESULTADOS REAIS
            </div>
            <h2 className="text-4xl lg:text-5xl font-black text-[#fefefe] mb-4">
              Antes e Depois
            </h2>
            <p className="text-xl text-[#fefefe]/70 max-w-3xl mx-auto">
              Veja os resultados naturais e harmoniosos alcançados com nossos tratamentos de toxina botulínica
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Video Card - First Item */}
            <div className="bg-[#1a1816] rounded-3xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300 border border-[#B9A38E]/20">
              <div className="p-6">
                <div className="relative w-full aspect-square rounded-2xl overflow-hidden">
                  <iframe
                    width="100%"
                    height="100%"
                    src="https://www.youtube.com/embed/Q2pFHb7fAh0?autoplay=1&mute=1&controls=0&loop=1&playlist=Q2pFHb7fAh0&modestbranding=1&showinfo=0&rel=0"
                    title="Resultado do Tratamento"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    className="w-full h-full object-cover"
                  ></iframe>
                  
                  {/* Video Label */}
                  <div className="absolute top-4 left-4 bg-[#B9A38E]/90 text-[#080705] px-3 py-1 rounded-full text-xs font-bold flex items-center gap-1">
                    <i className="ri-play-circle-fill"></i>
                    VÍDEO
                  </div>
                </div>

                <p className="text-center text-sm text-[#fefefe]/50 mt-4 italic">
                  Veja o resultado em movimento
                </p>
              </div>
            </div>

            {/* Before/After Image Cards */}
            {beforeAfterImages.map((item) => (
              <div key={item.id} className="bg-[#1a1816] rounded-3xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300 border border-[#B9A38E]/20">
                <div className="p-6">
                  {/* Before/After Slider */}
                  <div 
                    className="relative w-full aspect-square rounded-2xl overflow-hidden cursor-ew-resize select-none"
                    onMouseMove={(e) => handleSliderMove(item.id, e)}
                    onTouchMove={(e) => {
                      const touch = e.touches[0];
                      const rect = e.currentTarget.getBoundingClientRect();
                      const x = touch.clientX - rect.left;
                      const percentage = (x / rect.width) * 100;
                      setSliderPositions(prev => ({
                        ...prev,
                        [item.id]: Math.max(0, Math.min(100, percentage))
                      }));
                    }}
                  >
                    {/* After Image (Background) */}
                    <img 
                      src={item.after}
                      alt="Depois - Resultado do tratamento"
                      className="absolute inset-0 w-full h-full object-cover"
                    />
                    
                    {/* Before Image (Overlay with clip) */}
                    <div 
                      className="absolute inset-0 overflow-hidden"
                      style={{ clipPath: `inset(0 ${100 - sliderPositions[item.id]}% 0 0)` }}
                    >
                      <img 
                        src={item.before}
                        alt="Antes - Antes do tratamento"
                        className="absolute inset-0 w-full h-full object-cover"
                      />
                    </div>

                    {/* Slider Line */}
                    <div 
                      className="absolute top-0 bottom-0 w-1 bg-[#fefefe] shadow-2xl"
                      style={{ left: `${sliderPositions[item.id]}%` }}
                    >
                      {/* Slider Handle */}
                      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 bg-[#fefefe] rounded-full shadow-2xl flex items-center justify-center">
                        <i className="ri-arrow-left-right-line text-[#B9A38E] text-xl"></i>
                      </div>
                    </div>

                    {/* Labels */}
                    <div className="absolute top-4 left-4 bg-[#080705]/70 text-[#fefefe] px-3 py-1 rounded-full text-xs font-bold">
                      ANTES
                    </div>
                    <div className="absolute top-4 right-4 bg-[#B9A38E]/90 text-[#080705] px-3 py-1 rounded-full text-xs font-bold">
                      DEPOIS
                    </div>
                  </div>

                  <p className="text-center text-sm text-[#fefefe]/50 mt-4 italic">
                    Arraste para comparar os resultados
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* CTA after before/after */}
          <div className="text-center mt-12">
            <p className="text-2xl font-bold text-[#fefefe] mb-6">
              Conquiste Resultados Incríveis Como Estes!
            </p>
            <button
              onClick={() => handleWhatsApp()}
              className="bg-[#B9A38E] hover:bg-[#baa695] text-[#080705] px-10 py-4 rounded-full font-bold text-lg transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              Quero Garantir Minha Vaga Agora
            </button>
          </div>
        </div>
      </section>

      {/* Payment Highlight Section */}
      <section className="py-20 bg-gradient-to-br from-[#B9A38E] to-[#baa695] text-[#080705] relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-[#fefefe] rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#fefefe] rounded-full blur-3xl"></div>
        </div>
        
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-black mb-6">
              Parcelamento Inteligente
            </h2>
            <p className="text-2xl font-semibold opacity-95">
              Cuide da sua beleza sem comprometer o limite do seu cartão
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-[#080705]/10 backdrop-blur-sm rounded-3xl p-8 text-center border-2 border-[#080705]/20 hover:bg-[#080705]/20 transition-all duration-300">
              <div className="w-20 h-20 bg-[#fefefe] rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-bank-card-line text-4xl text-[#B9A38E]"></i>
              </div>
              <h3 className="text-2xl font-bold mb-4">12x Sem Juros</h3>
              <p className="text-lg opacity-90 leading-relaxed">
                Parcelas que cabem no seu bolso, sem surpresas no final do mês
              </p>
            </div>

            <div className="bg-[#080705]/10 backdrop-blur-sm rounded-3xl p-8 text-center border-2 border-[#080705]/20 hover:bg-[#080705]/20 transition-all duration-300">
              <div className="w-20 h-20 bg-[#fefefe] rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-wallet-line text-4xl text-[#B9A38E]"></i>
              </div>
              <h3 className="text-2xl font-bold mb-4">Limite Preservado</h3>
              <p className="text-lg opacity-90 leading-relaxed">
                Parcelas baixas que não comprometem seu limite para outras necessidades
              </p>
            </div>

            <div className="bg-[#080705]/10 backdrop-blur-sm rounded-3xl p-8 text-center border-2 border-[#080705]/20 hover:bg-[#080705]/20 transition-all duration-300">
              <div className="w-20 h-20 bg-[#fefefe] rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-hand-coin-line text-4xl text-[#B9A38E]"></i>
              </div>
              <h3 className="text-2xl font-bold mb-4">Investimento Inteligente</h3>
              <p className="text-lg opacity-90 leading-relaxed">
                Pague menos de R$ 250/mês e garanta sua beleza o ano todo
              </p>
            </div>
          </div>

          {/* CTA in payment section */}
          <div className="text-center mt-12">
            <button
              onClick={() => handleWhatsApp()}
              className="bg-[#fefefe] text-[#B9A38E] hover:bg-[#fefefe]/90 px-10 py-4 rounded-full font-bold text-lg transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              Quero Garantir Minha Vaga Agora
            </button>
          </div>
        </div>
      </section>

      {/* Early Bird Bonuses */}
      <section className="py-20 bg-[#080705]">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-block bg-yellow-600/20 text-yellow-400 border border-yellow-500/30 px-6 py-3 rounded-full font-bold text-sm mb-6">
              🎁 BÔNUS EXCLUSIVOS PARA QUEM FECHAR AGORA
            </div>
            <h2 className="text-4xl lg:text-5xl font-black text-[#fefefe] mb-4">
              Garanta Seus Presentes Especiais
            </h2>
            <p className="text-xl text-[#fefefe]/70">
              Benefícios exclusivos para os primeiros membros do Clube 2026
            </p>
          </div>

          {/* Monthly Gifts */}
          <div className="mb-16">
            <h3 className="text-3xl font-bold text-center text-[#fefefe] mb-8">
              Presente Especial por Mês de Aquisição
            </h3>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="bg-gradient-to-br from-blue-900/50 to-[#1a1816] rounded-2xl p-8 text-center shadow-lg hover:shadow-xl transition-all duration-300 border-2 border-blue-700/30">
                <div className="w-20 h-20 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-snowflake-line text-4xl text-[#fefefe]"></i>
                </div>
                <div className="inline-block bg-blue-600 text-[#fefefe] px-4 py-2 rounded-full font-bold text-sm mb-4">
                  DEZEMBRO
                </div>
                <h4 className="font-bold text-xl mb-3 text-[#fefefe]">1 Sessão de Coolpeel</h4>
                <p className="text-[#fefefe]/70 text-sm leading-relaxed">
                  Tratamento revolucionário de rejuvenescimento com laser CO2 fracionado
                </p>
              </div>

              <div className="bg-gradient-to-br from-green-900/50 to-[#1a1816] rounded-2xl p-8 text-center shadow-lg hover:shadow-xl transition-all duration-300 border-2 border-green-700/30">
                <div className="w-20 h-20 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-sparkling-line text-4xl text-[#fefefe]"></i>
                </div>
                <div className="inline-block bg-green-600 text-[#fefefe] px-4 py-2 rounded-full font-bold text-sm mb-4">
                  JANEIRO
                </div>
                <h4 className="font-bold text-xl mb-3 text-[#fefefe]">1 Sessão de Quadripico Intra-Oral</h4>
                <p className="text-[#fefefe]/70 text-sm leading-relaxed">
                  Tratamento inovador para harmonização facial e rejuvenescimento
                </p>
              </div>

              <div className="bg-gradient-to-br from-purple-900/50 to-[#1a1816] rounded-2xl p-8 text-center shadow-lg hover:shadow-xl transition-all duration-300 border-2 border-purple-700/30">
                <div className="w-20 h-20 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-contrast-drop-line text-4xl text-[#fefefe]"></i>
                </div>
                <div className="inline-block bg-purple-600 text-[#fefefe] px-4 py-2 rounded-full font-bold text-sm mb-4">
                  FEVEREIRO
                </div>
                <h4 className="font-bold text-xl mb-3 text-[#fefefe]">1 Sessão de Black Peel</h4>
                <p className="text-[#fefefe]/70 text-sm leading-relaxed">
                  Peeling de carvão ativado para renovação profunda da pele
                </p>
              </div>
            </div>
          </div>

          {/* Other Benefits */}
          <div className="mb-16">
            <h3 className="text-3xl font-bold text-center text-[#fefefe] mb-8">
              Benefícios Inclusos em Todos os Planos
            </h3>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="bg-gradient-to-br from-[#1a1816] to-[#080705] rounded-2xl p-6 text-center shadow-lg hover:shadow-xl transition-all duration-300 border-2 border-[#B9A38E]/30">
                <div className="w-16 h-16 bg-[#B9A38E] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-coupon-line text-3xl text-[#080705]"></i>
                </div>
                <h3 className="font-bold text-lg mb-2 text-[#fefefe]">Vouchers Mensais</h3>
                <p className="text-[#fefefe]/70 text-sm">Para campanhas especiais exclusivas</p>
              </div>

              <div className="bg-gradient-to-br from-[#1a1816] to-[#080705] rounded-2xl p-6 text-center shadow-lg hover:shadow-xl transition-all duration-300 border-2 border-[#B9A38E]/30">
                <div className="w-16 h-16 bg-[#B9A38E] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-drop-line text-3xl text-[#080705]"></i>
                </div>
                <h3 className="font-bold text-lg mb-2 text-[#fefefe]">Hidratação Premium</h3>
                <p className="text-[#fefefe]/70 text-sm">Por apenas R$ 15/mês adicional</p>
              </div>

              <div className="bg-gradient-to-br from-[#1a1816] to-[#080705] rounded-2xl p-6 text-center shadow-lg hover:shadow-xl transition-all duration-300 border-2 border-[#B9A38E]/30">
                <div className="w-16 h-16 bg-[#B9A38E] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-vip-crown-fill text-3xl text-[#080705]"></i>
                </div>
                <h3 className="font-bold text-lg mb-2 text-[#fefefe]">Atendimento VIP</h3>
                <p className="text-[#fefefe]/70 text-sm">Prioridade no agendamento</p>
              </div>

              <div className="bg-gradient-to-br from-[#1a1816] to-[#080705] rounded-2xl p-6 text-center shadow-lg hover:shadow-xl transition-all duration-300 border-2 border-[#B9A38E]/30">
                <div className="w-16 h-16 bg-[#B9A38E] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-eye-line text-3xl text-[#080705]"></i>
                </div>
                <h3 className="font-bold text-lg mb-2 text-[#fefefe]">Liftera Olhos</h3>
                <p className="text-[#fefefe]/70 text-sm">1 sessão de tratamento inclusa</p>
              </div>
            </div>
          </div>

          {/* Referral Bonus */}
          <div className="bg-gradient-to-br from-[#B9A38E] to-[#baa695] rounded-3xl p-10 text-[#080705] shadow-2xl">
            <div className="text-center mb-8">
              <div className="w-24 h-24 bg-[#fefefe] rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-user-heart-line text-5xl text-[#B9A38E]"></i>
              </div>
              <h3 className="text-3xl lg:text-4xl font-black mb-4">
                Bônus por Indicação
              </h3>
              <p className="text-xl opacity-95 max-w-2xl mx-auto">
                Indique um amigo e ganhe presentes incríveis!
              </p>
            </div>

            <div className="bg-[#080705]/10 backdrop-blur-sm rounded-2xl p-8 border-2 border-[#080705]/30">
              <div className="flex flex-col items-center gap-4 mb-6">
                <div className="flex-shrink-0">
                  <div className="w-16 h-16 bg-[#fefefe] rounded-full flex items-center justify-center">
                    <i className="ri-gift-2-line text-3xl text-[#B9A38E]"></i>
                  </div>
                </div>
                <div className="text-center w-full">
                  <h4 className="text-2xl font-bold mb-3">Quando Seu Amigo Fechar o Clube, Você Ganha:</h4>
                  <div className="space-y-3 max-w-2xl mx-auto">
                    <div className="flex items-center gap-3 bg-[#080705]/10 rounded-xl p-4">
                      <i className="ri-checkbox-circle-fill text-2xl"></i>
                      <p className="text-lg font-semibold">1 Sessão de Hidratação do Clube</p>
                    </div>
                    <div className="flex items-center justify-center gap-2 text-lg font-bold">
                      <span>OU</span>
                    </div>
                    <div className="flex items-center gap-3 bg-[#080705]/10 rounded-xl p-4">
                      <i className="ri-checkbox-circle-fill text-2xl"></i>
                      <p className="text-lg font-semibold">1 sessão de Laser para Qualidade de Pele</p>
                    </div>
                  </div>
                  <p className="text-sm opacity-90 mt-4 italic">
                    * Conforme avaliação da Dra. Ana Paula
                  </p>
                </div>
              </div>

              <div className="text-center pt-6 border-t border-[#080705]/30">
                <p className="text-lg font-semibold mb-4">
                  💡 Quanto mais amigos você indicar, mais presentes você ganha!
                </p>
                <a 
                  href="https://wa.me/556232741329?text=Olá!%20Quero%20saber%20mais%20sobre%20o%20programa%20de%20indicação%20do%20Clube%20Botox%202026!"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block bg-[#fefefe] text-[#B9A38E] hover:bg-[#fefefe]/90 px-8 py-4 rounded-full font-bold text-lg transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
                >
                  Saiba Mais Sobre Indicações
                </a>
              </div>
            </div>
          </div>

          <div className="mt-12 bg-gradient-to-r from-yellow-900/30 to-orange-900/30 rounded-3xl p-8 border-2 border-yellow-700/30">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0">
                <i className="ri-alarm-warning-line text-5xl text-orange-400"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-[#fefefe] mb-2">
                  ⚡ Oferta por Tempo Limitado
                </h3>
                <p className="text-lg text-[#fefefe]/80 leading-relaxed">
                  Os bônus especiais são exclusivos para os <strong>primeiros 50 membros</strong> que garantirem sua vaga no Clube Botox 2026. Após atingirmos esse número, os benefícios extras serão encerrados e os valores podem sofrer reajuste.
                </p>
              </div>
            </div>
          </div>

          {/* CTA after bonuses */}
          <div className="text-center mt-12">
            <button
              onClick={() => handleWhatsApp()}
              className="bg-[#B9A38E] hover:bg-[#baa695] text-[#080705] px-10 py-4 rounded-full font-bold text-lg transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              Quero Garantir Minha Vaga Agora
            </button>
          </div>
        </div>
      </section>

      {/* Plans Section */}
      <section id="planos" className="py-20 bg-gradient-to-b from-[#1a1816] to-[#080705]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl lg:text-5xl font-black text-[#fefefe] mb-4">
              Escolha Seu Plano Ideal
            </h2>
            <p className="text-xl text-[#fefefe]/70 mb-8">
              Todos os planos incluem benefícios exclusivos e economia garantida
            </p>
            
            {/* Gender Toggle */}
            <div className="inline-flex bg-[#1a1816] rounded-full p-1.5 shadow-xl border-2 border-[#B9A38E]/20">
              <button
                onClick={() => setSelectedGender('Feminino')}
                className={`px-8 py-3 rounded-full font-bold transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  selectedGender === 'Feminino'
                    ? 'bg-[#B9A38E] text-[#080705] shadow-lg scale-105'
                    : 'text-[#fefefe]/70 hover:text-[#fefefe]'
                }`}
              >
                <i className="ri-women-line mr-2 text-xl"></i>
                Feminino
              </button>
              <button
                onClick={() => setSelectedGender('Masculino')}
                className={`px-8 py-3 rounded-full font-bold transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  selectedGender === 'Masculino'
                    ? 'bg-[#B9A38E] text-[#080705] shadow-lg scale-105'
                    : 'text-[#fefefe]/70 hover:text-[#fefefe]'
                }`}
              >
                <i className="ri-men-line mr-2 text-xl"></i>
                Masculino
              </button>
            </div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {filteredPlans.map((plan) => (
              <div
                key={plan.id}
                className={`relative bg-[#1a1816] rounded-3xl shadow-xl overflow-hidden transition-all duration-300 hover:shadow-2xl hover:-translate-y-2 border ${
                  plan.featured ? 'ring-4 ring-[#B9A38E] scale-105 border-[#B9A38E]' : 'border-[#B9A38E]/20'
                }`}
              >
                {plan.featured && (
                  <div className="absolute top-0 left-0 right-0 bg-gradient-to-r from-[#B9A38E] to-[#baa695] text-[#080705] py-3 text-center font-bold text-sm">
                    <i className="ri-star-fill mr-1"></i>
                    MAIS ESCOLHIDO
                  </div>
                )}
                
                <div className={`p-6 ${plan.featured ? 'pt-16' : 'pt-6'}`}>
                  <div className="text-center mb-6">
                    <h3 className="text-xl font-bold text-[#fefefe] mb-2">{plan.title}</h3>
                    <p className="text-[#B9A38E] font-semibold text-sm">{plan.sessions}</p>
                  </div>

                  <div className="text-center mb-6">
                    <div className="bg-red-600/20 text-red-400 border border-red-500/30 px-3 py-1 rounded-full text-xs font-bold inline-block mb-3">
                      {plan.savings}
                    </div>
                    <p className="text-[#fefefe]/50 line-through text-sm mb-1">{plan.originalPrice}</p>
                    <p className="text-3xl font-black text-[#B9A38E] mb-2">{plan.finalPrice}</p>
                    <div className="bg-green-600/20 border-2 border-green-500/30 rounded-xl px-3 py-2">
                      <p className="text-green-400 font-bold text-sm">💳 {plan.installments}</p>
                      <p className="text-green-500 text-xs font-semibold">sem juros</p>
                    </div>
                  </div>

                  <div className="space-y-2 mb-6">
                    {plan.benefits.map((benefit, index) => (
                      <div key={index} className="flex items-start gap-2">
                        <i className="ri-checkbox-circle-fill text-[#B9A38E] text-base mt-0.5 flex-shrink-0"></i>
                        <span className="text-xs text-[#fefefe]/80 leading-tight">{benefit}</span>
                      </div>
                    ))}
                  </div>

                  <button
                    onClick={() => handleWhatsApp(plan)}
                    className={`w-full py-4 rounded-full font-bold transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap ${
                      plan.featured
                        ? 'bg-[#B9A38E] hover:bg-[#baa695] text-[#080705]'
                        : 'bg-[#B9A38E]/20 hover:bg-[#B9A38E]/30 text-[#fefefe] border border-[#B9A38E]/50'
                    }`}
                  >
                    Garantir Minha Vaga
                  </button>
                </div>
              </div>
            ))}
          </div>

          {/* Guarantee Badge */}
          <div className="mt-16 text-center">
            <div className="inline-block bg-[#1a1816] rounded-2xl shadow-xl p-8 border-2 border-green-700/30">
              <i className="ri-shield-check-fill text-6xl text-green-500 mb-4"></i>
              <h3 className="text-2xl font-bold text-[#fefefe] mb-2">Garantia de Satisfação</h3>
              <p className="text-[#fefefe]/70 max-w-2xl">
                Sua satisfação é nossa prioridade. Todos os tratamentos são realizados pela Dra. Ana Paula Rocha com produtos premium e equipamentos de última geração.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Social Proof */}
      <section className="py-20 bg-[#080705]">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-black text-[#fefefe] mb-4">
              O Que Nossos Clientes Dizem
            </h2>
            <p className="text-xl text-[#fefefe]/70">Resultados reais de quem confia na Pele e Plástica</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                name: 'Mariana Silva',
                age: '42 anos',
                text: 'Faço parte do clube há 2 anos e não troco por nada! A economia é real e os resultados são incríveis. A Dra. Ana Paula tem mãos de fada!',
                rating: 5
              },
              {
                name: 'Roberto Mendes',
                age: '38 anos',
                text: 'Sempre tive receio de fazer botox, mas a equipe me deixou super confortável. O resultado ficou natural e masculino, exatamente como eu queria.',
                rating: 5
              },
              {
                name: 'Juliana Costa',
                age: '35 anos',
                text: 'O melhor investimento que fiz! Parcelo no cartão sem pesar no bolso e fico linda o ano todo. Os bônus do clube são maravilhosos!',
                rating: 5
              }
            ].map((testimonial, index) => (
              <div key={index} className="bg-gradient-to-br from-[#1a1816] to-[#080705] rounded-2xl p-8 shadow-lg border border-[#B9A38E]/20">
                <div className="flex gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-500 text-xl"></i>
                  ))}
                </div>
                <p className="text-[#fefefe]/80 mb-6 italic leading-relaxed">"{testimonial.text}"</p>
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-[#B9A38E] rounded-full flex items-center justify-center text-[#080705] font-bold text-xl">
                    {testimonial.name.charAt(0)}
                  </div>
                  <div>
                    <p className="font-bold text-[#fefefe]">{testimonial.name}</p>
                    <p className="text-sm text-[#fefefe]/50">{testimonial.age}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* CTA after testimonials */}
          <div className="text-center mt-12">
            <button
              onClick={() => handleWhatsApp()}
              className="bg-[#B9A38E] hover:bg-[#baa695] text-[#080705] px-10 py-4 rounded-full font-bold text-lg transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              Quero Garantir Minha Vaga Agora
            </button>
          </div>
        </div>
      </section>

      {/* Doctor Section */}
      <section className="py-20 bg-gradient-to-b from-[#1a1816] to-[#080705]">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-[#B9A38E]/20 to-transparent rounded-3xl transform -rotate-3"></div>
              <img 
                src="https://clubebotox.peleplastica.com.br/antesedepois/Dra_Ana_Paula_Rocha_Dermato.png"
                alt="Dra. Ana Paula Rocha"
                className="relative rounded-3xl shadow-2xl w-full h-[600px] object-cover object-top"
              />
            </div>
            <div className="space-y-6">
              <div className="inline-block bg-[#B9A38E]/20 text-[#B9A38E] border border-[#B9A38E]/30 px-4 py-2 rounded-full text-sm font-bold">
                Sua Especialista em Beleza Natural
              </div>
              <h2 className="text-4xl lg:text-5xl font-black text-[#fefefe]">Dra. Ana Paula Rocha</h2>
              <p className="text-xl text-[#B9A38E] font-bold">CRM 14278/GO | RQE 2339</p>
              
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-2xl text-[#B9A38E] mt-1"></i>
                  <p className="text-lg text-[#fefefe]/80">
                    <strong className="text-[#fefefe]">Especialista em Dermatologia</strong> com mais de 21 anos de experiência
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-2xl text-[#B9A38E] mt-1"></i>
                  <p className="text-lg text-[#fefefe]/80">
                    <strong className="text-[#fefefe]">Responsável Técnica</strong> da Clínica Pele e Plástica
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-2xl text-[#B9A38E] mt-1"></i>
                  <p className="text-lg text-[#fefefe]/80">
                    <strong className="text-[#fefefe]">Atualização constante</strong> nas técnicas mais modernas de aplicação
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-2xl text-[#B9A38E] mt-1"></i>
                  <p className="text-lg text-[#fefefe]/80">
                    <strong className="text-[#fefefe]">Resultados naturais e harmoniosos</strong> garantidos
                  </p>
                </div>
              </div>

              <div className="bg-gradient-to-r from-[#B9A38E]/20 to-transparent rounded-2xl p-6 border-l-4 border-[#B9A38E]">
                <p className="text-[#fefefe]/80 italic leading-relaxed">
                  "Meu compromisso é realçar a beleza natural de cada paciente, respeitando suas características únicas e proporcionando resultados que aumentem a autoestima e confiança."
                </p>
                <p className="text-[#B9A38E] font-bold mt-3">- Dra. Ana Paula Rocha</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-[#080705]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl lg:text-5xl font-black text-[#fefefe] mb-4">Perguntas Frequentes</h2>
            <p className="text-xl text-[#fefefe]/70">Tire todas as suas dúvidas sobre o Clube Botox 2026</p>
          </div>
          <div className="space-y-4">
            {[
              {
                q: 'Como funciona o parcelamento em 12x sem juros?',
                a: 'Você pode dividir o valor total do seu plano em até 12 parcelas iguais no cartão de crédito, sem nenhum acréscimo de juros. As parcelas são fixas e não comprometem seu limite, pois são valores acessíveis que cabem no seu orçamento mensal.'
              },
              {
                q: 'Quando posso usar minhas sessões?',
                a: 'Você tem 12 meses para utilizar todas as sessões do seu plano, podendo agendar conforme sua necessidade e disponibilidade. Recomendamos espaçamento de 4-6 meses entre as aplicações para resultados ideais.'
              },
              {
                q: 'Quais são os brindes por fechar antecipadamente?',
                a: 'Os primeiros 50 membros recebem: presente especial no mês da aquisição, vouchers mensais para campanhas exclusivas, acesso a hidratação nutritiva por apenas R$ 15/mês e atendimento prioritário no agendamento.'
              },
              {
                q: 'O resultado fica natural?',
                a: 'Sim! A Dra. Ana Paula é especialista em resultados naturais e harmoniosos. O objetivo é realçar sua beleza, suavizar linhas de expressão e proporcionar um aspecto rejuvenescido, mas sempre mantendo suas características naturais.'
              },
              {
                q: 'Qual a diferença entre Toxina Clássica e Full Face?',
                a: 'A Toxina Clássica trata as áreas mais comuns (testa, glabela e pés de galinha). O Full Face é um tratamento completo que abrange mais áreas do rosto para um resultado ainda mais harmonioso e rejuvenescedor.'
              },
              {
                q: 'Posso cancelar ou transferir meu plano?',
                a: 'As sessões são pessoais e intransferíveis. Em caso de necessidade de cancelamento, entre em contato conosco para avaliarmos sua situação individualmente.'
              },
              {
                q: 'Os produtos utilizados são seguros?',
                a: 'Sim! Utilizamos apenas produtos aprovados pela ANVISA, de marcas renomadas internacionalmente. Todos os procedimentos seguem rigorosos protocolos de segurança e são realizados em ambiente clínico adequado.'
              },
              {
                q: 'Quantas vagas estão disponíveis?',
                a: 'Estamos limitando a apenas 50 vagas para o Clube Botox 2026, garantindo atendimento personalizado e exclusivo para cada membro. Após atingir esse número, as inscrições serão encerradas.'
              }
            ].map((faq, index) => (
              <details key={index} className="bg-gradient-to-br from-[#1a1816] to-[#080705] rounded-2xl shadow-md overflow-hidden group border-2 border-[#B9A38E]/20 hover:border-[#B9A38E]/50 transition-all duration-300">
                <summary className="px-8 py-6 cursor-pointer font-bold text-lg text-[#fefefe] hover:text-[#B9A38E] transition-colors duration-300 flex items-center justify-between">
                  {faq.q}
                  <i className="ri-arrow-down-s-line text-2xl group-open:rotate-180 transition-transform duration-300"></i>
                </summary>
                <div className="px-8 pb-6 text-[#fefefe]/80 leading-relaxed">
                  {faq.a}
                </div>
              </details>
            ))}
          </div>

          {/* CTA after FAQ */}
          <div className="text-center mt-12">
            <button
              onClick={() => handleWhatsApp()}
              className="bg-[#B9A38E] hover:bg-[#baa695] text-[#080705] px-10 py-4 rounded-full font-bold text-lg transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              Quero Garantir Minha Vaga Agora
            </button>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-20 bg-gradient-to-br from-[#B9A38E] via-[#baa695] to-[#B9A38E] text-[#080705] relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#fefefe] rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-[#fefefe] rounded-full blur-3xl"></div>
        </div>
        
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <div className="inline-block bg-[#080705]/20 backdrop-blur-sm text-[#080705] px-6 py-3 rounded-full font-bold text-sm mb-6 animate-pulse">
            ⏰ ÚLTIMAS VAGAS DISPONÍVEIS
          </div>
          
          <h2 className="text-4xl lg:text-6xl font-black mb-6 leading-tight">
            Garanta Sua Vaga no Clube Botox 2026
          </h2>
          
          <p className="text-2xl mb-4 font-semibold">
            Apenas 50 vagas disponíveis
          </p>
          
          <p className="text-xl mb-8 opacity-95 leading-relaxed">
            Não perca a oportunidade de cuidar da sua beleza com economia, parcelamento facilitado e benefícios exclusivos durante todo o ano de 2026!
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
            <button
              onClick={() => handleWhatsApp()}
              className="bg-[#fefefe] text-[#B9A38E] hover:bg-[#fefefe]/90 px-10 py-5 rounded-full font-black text-xl transition-all duration-300 shadow-2xl hover:shadow-3xl hover:scale-105 cursor-pointer whitespace-nowrap inline-flex items-center justify-center gap-3"
            >
              <i className="ri-whatsapp-line text-3xl"></i>
              Quero Minha Vaga Agora
            </button>
            <a 
              href="#planos"
              className="bg-transparent border-3 border-[#080705] text-[#080705] hover:bg-[#080705] hover:text-[#fefefe] px-10 py-5 rounded-full font-black text-xl transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Ver Planos
            </a>
          </div>

          <div className="flex flex-wrap justify-center gap-8 pt-8 border-t border-[#080705]/30">
            <div className="text-center">
              <p className="text-3xl font-black mb-1">12x</p>
              <p className="text-sm opacity-90">Sem Juros</p>
            </div>
            <div className="text-center">
              <p className="text-3xl font-black mb-1">50%</p>
              <p className="text-sm opacity-90">de Economia</p>
            </div>
            <div className="text-center">
              <p className="text-3xl font-black mb-1">100%</p>
              <p className="text-sm opacity-90">Seguro</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#080705] text-[#fefefe] py-12 border-t border-[#B9A38E]/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-8 mb-8">
            <div>
              <img 
                src="https://peleplastica.com.br/wp-content/uploads/2024/09/Logo.png" 
                alt="Pele e Plástica" 
                className="h-16 w-auto brightness-0 invert"
              />
              <p className="text-[#fefefe]/70">
                Clínica de Dermatologia e Estética em Goiânia
              </p>
            </div>
            <div>
              <h4 className="font-bold text-lg mb-4">Contato</h4>
              <div className="space-y-2 text-[#fefefe]/70">
                <p className="flex items-center gap-2">
                  <i className="ri-map-pin-line"></i>
                  Av. Portugal, 883 - St. Marista, Goiânia - GO
                </p>
                <p className="flex items-center gap-2">
                  <i className="ri-phone-line"></i>
                  (62) 3274-1329
                </p>
              </div>
            </div>
            <div>
              <h4 className="font-bold text-lg mb-4">Redes Sociais</h4>
              <div className="flex gap-4">
                <a 
                  href="https://www.instagram.com/clinicapeleeplastica/" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-[#fefefe]/10 hover:bg-[#B9A38E] rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer"
                >
                  <i className="ri-instagram-line text-xl"></i>
                </a>
                <a 
                  href="https://wa.me/556232741329"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-[#fefefe]/10 hover:bg-[#B9A38E] rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-xl"></i>
                </a>
              </div>
            </div>
          </div>
          <div className="border-t border-[#B9A38E]/20 pt-8 text-center text-[#fefefe]/70">
            <p>RT: Ana Paula Rocha - CRM 14278/GO RQE 2339</p>
            <p className="mt-2">© 2026 Clínica Pele e Plástica. Todos os direitos reservados.</p>
            <p className="mt-4">
              <a href="https://www.instagram.com/rodriigocoelho" target="_blank" rel="noopener noreferrer" className="hover:text-[#B9A38E] transition-colors cursor-pointer">
                RS DIGITAL 
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
